// GENERATED CODE - DO NOT MODIFY BY HAND
// For all changes please modify icons-generator/src/main/resources/web/monochromeColoredOnDarkGroupIcons.template
// file first and regenerate.
import { type LazyIcon, type LazyIconsGroup } from '@DS/components/icons/icons.types'
import { svgLazyLoader } from '@Utils/icons'

const AveRenfe = svgLazyLoader('supplier/colored/ave_renfe')
const AveRenfeMonochrome = svgLazyLoader('supplier/monochrome/ave_renfe')
const Blablabus = svgLazyLoader('supplier/colored/blablabus')
const BlablabusMonochrome = svgLazyLoader('supplier/monochrome/blablabus')
const Blablacar = svgLazyLoader('supplier/colored/blablacar')
const BlablacarMonochrome = svgLazyLoader('supplier/monochrome/blablacar')
const CarReservationMonochrome = svgLazyLoader('supplier/monochrome/car_reservation')
const Cfl = svgLazyLoader('supplier/colored/cfl')
const CflMonochrome = svgLazyLoader('supplier/monochrome/cfl')
const DarkChauffeurInoui = svgLazyLoader('supplier/dark/chauffeur_inoui')
const DarkCoeurInoui = svgLazyLoader('supplier/dark/coeur_inoui')
const DarkConfortInoui = svgLazyLoader('supplier/dark/confort_inoui')
const DarkFlecheInoui = svgLazyLoader('supplier/dark/fleche_inoui')
const DarkJuniorEtCieInoui = svgLazyLoader('supplier/dark/junior_et_cie_inoui')
const DarkLeBarInoui = svgLazyLoader('supplier/dark/le_bar_inoui')
const DarkLocationInoui = svgLazyLoader('supplier/dark/location_inoui')
const DarkMesBagagesInoui = svgLazyLoader('supplier/dark/mes_bagages_inoui')
const DarkTgv = svgLazyLoader('supplier/dark/tgv')
const DarkWifiInoui = svgLazyLoader('supplier/dark/wifi_inoui')
const Db = svgLazyLoader('supplier/colored/db')
const DbMonochrome = svgLazyLoader('supplier/monochrome/db')
const DbSncf = svgLazyLoader('supplier/colored/db_sncf')
const DbSncfMonochrome = svgLazyLoader('supplier/monochrome/db_sncf')
const Eurostar = svgLazyLoader('supplier/colored/eurostar')
const EurostarMonochrome = svgLazyLoader('supplier/monochrome/eurostar')
const Flixbus = svgLazyLoader('supplier/colored/flixbus')
const FlixbusMonochrome = svgLazyLoader('supplier/monochrome/flixbus')
const GoogleMaps = svgLazyLoader('supplier/colored/google_maps')
const GoogleMapsMonochrome = svgLazyLoader('supplier/monochrome/google_maps')
const GrandeVitesseMonochrome = svgLazyLoader('supplier/monochrome/grande_vitesse')
const Ice = svgLazyLoader('supplier/colored/ice')
const IceMonochrome = svgLazyLoader('supplier/monochrome/ice')
const Intercites = svgLazyLoader('supplier/colored/intercites')
const IntercitesDeNuit = svgLazyLoader('supplier/colored/intercites_de_nuit')
const IntercitesDeNuitMonochrome = svgLazyLoader('supplier/monochrome/intercites_de_nuit')
const IntercitesMonochrome = svgLazyLoader('supplier/monochrome/intercites')
const Lio = svgLazyLoader('supplier/colored/lio')
const NavetteMonochrome = svgLazyLoader('supplier/monochrome/navette')
const OuigoEspagneMonochrome = svgLazyLoader('supplier/monochrome/ouigo_espagne')
const OuigoGrandeVitesse = svgLazyLoader('supplier/colored/ouigo_grande_vitesse')
const OuigoGrandeVitesseMonochrome = svgLazyLoader('supplier/monochrome/ouigo_grande_vitesse')
const OuigoVitesseClassique = svgLazyLoader('supplier/colored/ouigo_vitesse_classique')
const OuigoVitesseClassiqueMonochrome = svgLazyLoader('supplier/monochrome/ouigo_vitesse_classique')
const Plans = svgLazyLoader('supplier/colored/plans')
const RailteamMonochrome = svgLazyLoader('supplier/monochrome/railteam')
const RegionalMonochrome = svgLazyLoader('supplier/monochrome/regional')
const Renfe = svgLazyLoader('supplier/colored/renfe')
const RenfeMonochrome = svgLazyLoader('supplier/monochrome/renfe')
const Sncb = svgLazyLoader('supplier/colored/sncb')
const SncfIntercitesMonochrome = svgLazyLoader('supplier/monochrome/sncf_intercites')
const SncfMonochrome = svgLazyLoader('supplier/monochrome/sncf')
const SpecialTrainMonochrome = svgLazyLoader('supplier/monochrome/special_train')
const Ter = svgLazyLoader('supplier/colored/ter')
const TerCarMonochrome = svgLazyLoader('supplier/monochrome/ter_car')
const TerMonochrome = svgLazyLoader('supplier/monochrome/ter')
const TergvMonochrome = svgLazyLoader('supplier/monochrome/tergv')
const Tgv = svgLazyLoader('supplier/colored/tgv')
const TgvInoui = svgLazyLoader('supplier/colored/tgv_inoui')
const TgvInouiMonochrome = svgLazyLoader('supplier/monochrome/tgv_inoui')
const TgvLyria = svgLazyLoader('supplier/colored/tgv_lyria')
const TgvLyriaMonochrome = svgLazyLoader('supplier/monochrome/tgv_lyria')
const TgvMonochrome = svgLazyLoader('supplier/monochrome/tgv')
const Trenitalia = svgLazyLoader('supplier/colored/trenitalia')
const Zou10voyages = svgLazyLoader('supplier/colored/zou_10voyages')
const Zou1voyage = svgLazyLoader('supplier/colored/zou_1voyage')
const Zou1voyageMinigroupe = svgLazyLoader('supplier/colored/zou_1voyage_minigroupe')
const ZouAnnuel = svgLazyLoader('supplier/colored/zou_annuel')
const ZouElevated = svgLazyLoader('supplier/colored/zou_elevated')
const ZouMalin = svgLazyLoader('supplier/colored/zou_malin')
const ZouMensuel = svgLazyLoader('supplier/colored/zou_mensuel')
const ZouMensuelFlex = svgLazyLoader('supplier/colored/zou_mensuel_flex')
const ZouPassEtude = svgLazyLoader('supplier/colored/zou_pass_etude')
const ZouSolidaire = svgLazyLoader('supplier/colored/zou_solidaire')
const ZouSolidairePlus = svgLazyLoader('supplier/colored/zou_solidaire_plus')
const ZouSurface = svgLazyLoader('supplier/colored/zou_surface')

const ALL_SUPPLIER_ICONS = [
  'ave_renfe',
  'ave_renfe_monochrome',
  'blablabus',
  'blablabus_monochrome',
  'blablacar',
  'blablacar_monochrome',
  'car_reservation_monochrome',
  'cfl',
  'cfl_monochrome',
  'dark_chauffeur_inoui',
  'dark_coeur_inoui',
  'dark_confort_inoui',
  'dark_fleche_inoui',
  'dark_junior_et_cie_inoui',
  'dark_le_bar_inoui',
  'dark_location_inoui',
  'dark_mes_bagages_inoui',
  'dark_tgv',
  'dark_wifi_inoui',
  'db',
  'db_monochrome',
  'db_sncf',
  'db_sncf_monochrome',
  'eurostar',
  'eurostar_monochrome',
  'flixbus',
  'flixbus_monochrome',
  'google_maps',
  'google_maps_monochrome',
  'grande_vitesse_monochrome',
  'ice',
  'ice_monochrome',
  'intercites',
  'intercites_de_nuit',
  'intercites_de_nuit_monochrome',
  'intercites_monochrome',
  'lio',
  'navette_monochrome',
  'ouigo_espagne_monochrome',
  'ouigo_grande_vitesse',
  'ouigo_grande_vitesse_monochrome',
  'ouigo_vitesse_classique',
  'ouigo_vitesse_classique_monochrome',
  'plans',
  'railteam_monochrome',
  'regional_monochrome',
  'renfe',
  'renfe_monochrome',
  'sncb',
  'sncf_intercites_monochrome',
  'sncf_monochrome',
  'special_train_monochrome',
  'ter',
  'ter_car_monochrome',
  'ter_monochrome',
  'tergv_monochrome',
  'tgv',
  'tgv_inoui',
  'tgv_inoui_monochrome',
  'tgv_lyria',
  'tgv_lyria_monochrome',
  'tgv_monochrome',
  'trenitalia',
  'zou_10voyages',
  'zou_1voyage',
  'zou_1voyage_minigroupe',
  'zou_annuel',
  'zou_elevated',
  'zou_malin',
  'zou_mensuel',
  'zou_mensuel_flex',
  'zou_pass_etude',
  'zou_solidaire',
  'zou_solidaire_plus',
  'zou_surface',
] as const
export type SupplierIcon = (typeof ALL_SUPPLIER_ICONS)[number]

const ICONS: LazyIconsGroup<SupplierIcon> = {
  ave_renfe: AveRenfe,
  ave_renfe_monochrome: AveRenfeMonochrome,
  blablabus: Blablabus,
  blablabus_monochrome: BlablabusMonochrome,
  blablacar: Blablacar,
  blablacar_monochrome: BlablacarMonochrome,
  car_reservation_monochrome: CarReservationMonochrome,
  cfl: Cfl,
  cfl_monochrome: CflMonochrome,
  dark_chauffeur_inoui: DarkChauffeurInoui,
  dark_coeur_inoui: DarkCoeurInoui,
  dark_confort_inoui: DarkConfortInoui,
  dark_fleche_inoui: DarkFlecheInoui,
  dark_junior_et_cie_inoui: DarkJuniorEtCieInoui,
  dark_le_bar_inoui: DarkLeBarInoui,
  dark_location_inoui: DarkLocationInoui,
  dark_mes_bagages_inoui: DarkMesBagagesInoui,
  dark_tgv: DarkTgv,
  dark_wifi_inoui: DarkWifiInoui,
  db: Db,
  db_monochrome: DbMonochrome,
  db_sncf: DbSncf,
  db_sncf_monochrome: DbSncfMonochrome,
  eurostar: Eurostar,
  eurostar_monochrome: EurostarMonochrome,
  flixbus: Flixbus,
  flixbus_monochrome: FlixbusMonochrome,
  google_maps: GoogleMaps,
  google_maps_monochrome: GoogleMapsMonochrome,
  grande_vitesse_monochrome: GrandeVitesseMonochrome,
  ice: Ice,
  ice_monochrome: IceMonochrome,
  intercites: Intercites,
  intercites_de_nuit: IntercitesDeNuit,
  intercites_de_nuit_monochrome: IntercitesDeNuitMonochrome,
  intercites_monochrome: IntercitesMonochrome,
  lio: Lio,
  navette_monochrome: NavetteMonochrome,
  ouigo_espagne_monochrome: OuigoEspagneMonochrome,
  ouigo_grande_vitesse: OuigoGrandeVitesse,
  ouigo_grande_vitesse_monochrome: OuigoGrandeVitesseMonochrome,
  ouigo_vitesse_classique: OuigoVitesseClassique,
  ouigo_vitesse_classique_monochrome: OuigoVitesseClassiqueMonochrome,
  plans: Plans,
  railteam_monochrome: RailteamMonochrome,
  regional_monochrome: RegionalMonochrome,
  renfe: Renfe,
  renfe_monochrome: RenfeMonochrome,
  sncb: Sncb,
  sncf_intercites_monochrome: SncfIntercitesMonochrome,
  sncf_monochrome: SncfMonochrome,
  special_train_monochrome: SpecialTrainMonochrome,
  ter: Ter,
  ter_car_monochrome: TerCarMonochrome,
  ter_monochrome: TerMonochrome,
  tergv_monochrome: TergvMonochrome,
  tgv: Tgv,
  tgv_inoui: TgvInoui,
  tgv_inoui_monochrome: TgvInouiMonochrome,
  tgv_lyria: TgvLyria,
  tgv_lyria_monochrome: TgvLyriaMonochrome,
  tgv_monochrome: TgvMonochrome,
  trenitalia: Trenitalia,
  zou_10voyages: Zou10voyages,
  zou_1voyage: Zou1voyage,
  zou_1voyage_minigroupe: Zou1voyageMinigroupe,
  zou_annuel: ZouAnnuel,
  zou_elevated: ZouElevated,
  zou_malin: ZouMalin,
  zou_mensuel: ZouMensuel,
  zou_mensuel_flex: ZouMensuelFlex,
  zou_pass_etude: ZouPassEtude,
  zou_solidaire: ZouSolidaire,
  zou_solidaire_plus: ZouSolidairePlus,
  zou_surface: ZouSurface,
}

const isSupplierIcon = (supplierKey: string): supplierKey is SupplierIcon =>
  ALL_SUPPLIER_ICONS.includes(supplierKey as SupplierIcon)

const getSupplierIcon = (
  supplierKey: string | undefined,
  icons: LazyIconsGroup<SupplierIcon> = ICONS,
): LazyIcon | undefined => (supplierKey && isSupplierIcon(supplierKey) ? icons[supplierKey] : undefined)

export const getSupplierIcons = (): LazyIconsGroup<SupplierIcon> => ICONS

export const getSupplierColoredIcon = (supplierKey: string | undefined): LazyIcon | undefined => {
  const lowerCaseSupplierKey = supplierKey?.toLowerCase()

  return getSupplierIcon(lowerCaseSupplierKey)
}

export const getSupplierMonochromeIcon = (supplierKey: string | undefined): LazyIcon | undefined => {
  const lowerCaseSupplierKey = `${supplierKey?.toLowerCase()}_monochrome`

  return getSupplierIcon(lowerCaseSupplierKey)
}

export const getSupplierOnDarkIcon = (supplierKey: string | undefined): LazyIcon | undefined => {
  const lowerCaseSupplierKey = `dark_${supplierKey?.toLowerCase()}`

  return getSupplierIcon(lowerCaseSupplierKey)
}
